var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJcbCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 38,
    viewBox: "0 0 60 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 37,
    rx: 7.5,
    fill: "white",
    stroke: "#D3D3D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 27.522C48 30.5171 45.5611 32.956 42.566 32.956H13V11.434C13 8.43887 15.4389 6 18.434 6H48V27.522Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3728 22.0024H40.6191C40.6833 22.0024 40.833 21.981 40.8972 21.981C41.3251 21.8954 41.6888 21.5104 41.6888 20.9755C41.6888 20.4621 41.3251 20.077 40.8972 19.97C40.833 19.9486 40.7047 19.9486 40.6191 19.9486H38.3728V22.0024Z",
    fill: "url(#paint0_linear_1_133)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3625 7.81844C38.2231 7.81844 36.4688 9.55132 36.4688 11.7121V15.7555H41.967C42.0953 15.7555 42.2451 15.7555 42.3521 15.7769C43.5929 15.8411 44.5128 16.4829 44.5128 17.5953C44.5128 18.4725 43.8924 19.2212 42.7371 19.371V19.4138C43.9994 19.4994 44.9621 20.2054 44.9621 21.2964C44.9621 22.4731 43.8924 23.2433 42.4804 23.2433H36.4474V31.1589H42.1595C44.2989 31.1589 46.0532 29.426 46.0532 27.2653V7.81844H40.3625Z",
    fill: "url(#paint1_linear_1_133)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4107 17.852C41.4107 17.3386 41.047 16.9963 40.6191 16.9321C40.5763 16.9321 40.4693 16.9107 40.4052 16.9107H38.3728V18.7933H40.4052C40.4693 18.7933 40.5977 18.7933 40.6191 18.7719C41.047 18.7078 41.4107 18.3655 41.4107 17.852Z",
    fill: "url(#paint2_linear_1_133)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8405 7.81844C16.7011 7.81844 14.9468 9.55132 14.9468 11.7121V21.3178C16.0379 21.8527 17.1718 22.195 18.3056 22.195C19.6534 22.195 20.3808 21.382 20.3808 20.2695V15.7341H23.7182V20.2481C23.7182 22.0024 22.6272 23.4358 18.9261 23.4358C16.6797 23.4358 14.9254 22.9437 14.9254 22.9437V31.1375H20.6375C22.7769 31.1375 24.5312 29.4046 24.5312 27.2439V7.81844H18.8405Z",
    fill: "url(#paint3_linear_1_133)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6015 7.81844C27.4621 7.81844 25.7079 9.55132 25.7079 11.7121V16.8038C26.692 15.9694 28.4035 15.4346 31.1632 15.5629C32.6394 15.6271 34.2225 16.0336 34.2225 16.0336V17.6809C33.431 17.2744 32.4896 16.9107 31.2702 16.8252C29.1736 16.6754 27.9114 17.7023 27.9114 19.4994C27.9114 21.3178 29.1736 22.3447 31.2702 22.1736C32.4896 22.088 33.431 21.7029 34.2225 21.3178V22.9651C34.2225 22.9651 32.6608 23.3716 31.1632 23.4358C28.4035 23.5642 26.692 23.0293 25.7079 22.195V31.1803H31.42C33.5593 31.1803 35.3136 29.4474 35.3136 27.2867V7.81844H29.6015Z",
    fill: "url(#paint4_linear_1_133)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_133",
    x1: 36.4652,
    y1: 20.9781,
    x2: 46.0789,
    y2: 20.9781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_133",
    x1: 36.465,
    y1: 19.4793,
    x2: 46.0794,
    y2: 19.4793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_133",
    x1: 36.4649,
    y1: 17.8493,
    x2: 46.079,
    y2: 17.8493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_133",
    x1: 14.9423,
    y1: 19.4793,
    x2: 24.7049,
    y2: 19.4793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_133",
    x1: 25.6525,
    y1: 19.4793,
    x2: 35.1343,
    y2: 19.4793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcbCard);
export default __webpack_public_path__ + "static/media/jcb-card.4d1d3020e5fc3149bb40a0e49a3a3c2e.svg";
export { ForwardRef as ReactComponent };